// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".filters-dropdown[data-v-57496b1a] .buttons-wrapper{width:100%}.filters-dropdown[data-v-57496b1a] .buttons-wrapper fieldset{width:200px}.filter-properties>fieldset[data-v-57496b1a],.filter-accounts>fieldset[data-v-57496b1a]{margin:0 !important}", ""]);
// Exports
module.exports = exports;
